import { OpenInExternalAppDropdownItems } from '@features/openInExternalApp/components/OpenInExternalAppMenuItems.js';
import { useHasSelectionOpener } from '@features/openInExternalApp/selectionOpener.js';
import { useOpenInExternalAppMessages } from '@features/openInExternalApp/translations/useOpenInExternalAppMessages.js';
import { SubmenuHeader } from '@shared/components/SubmenuHeader.js';
import { useAppSelector } from '@shared/hooks/useAppSelector.js';
import { Fragment, type ReactElement } from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';

export function OpenExternallySubmenu(): ReactElement {
  const lat = useAppSelector((state) => state.map.lat);

  const lon = useAppSelector((state) => state.map.lon);

  const zoom = useAppSelector((state) => state.map.zoom);

  const oeam = useOpenInExternalAppMessages();

  const selectionOpens = useHasSelectionOpener();

  return (
    <Fragment key="openExternally">
      <SubmenuHeader
        icon={<FaExternalLinkAlt />}
        title={oeam?.openInExternal}
      />

      <OpenInExternalAppDropdownItems
        lat={lat}
        lon={lon}
        zoom={zoom}
        showKbdShortcut
        targetKbdShortcut={!selectionOpens}
      />
    </Fragment>
  );
}
